'use client';

import { TasticProps } from '../types';
import HeroBanner from 'components/commercetools-ui/organisms/hero-banner';
import { useUserStatus } from './useUserStatus';
import { useParams } from 'next/navigation';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mobile } from 'helpers/utils/screensizes';

const HeroBannerTastic = ({ data }: TasticProps<any>) => {
  const { slug = [], previewId = '' } = useParams();
  const { isNewUser } = useUserStatus({ numberOfDays: data?.numberOfDays });

  // Hide first slide for old users
  const bannerData = isNewUser === false ? { ...data, banner: data?.banner?.slice(1) } : data;
  const [isDesktopSize] = useMediaQuery(mobile);

  if (
    slug.length === 0 &&
    !data?.showForAllUsers &&
    isNewUser === null
  ) {
    return (<div className='mx-0 sm:mx-24 md:mx-75 lg:mx-76 xl:mx-0'>
      <div
        className="relative max-h-[410px] w-full overflow-hidden rounded-xl bg-gray-200 animate-pulse sm:max-h-[482px] sm:rounded-2xl"
        style={{
          aspectRatio:
            isDesktopSize ? data?.aspectRatioDesktop : data?.aspectRatioMobile,
        }}
      />
    </div>
    );
  }

  if (slug.length > 0 && slug?.[0] === data?.categoryKey) {
    return <HeroBanner {...data} />;
  }
  if (Boolean(previewId) && data?.categoryKey) {
    if (data?.categoryKey === 'gmsb_wallart_tabletop' || data?.categoryKey === 'print') {
      return <HeroBanner {...data} />;
    }
    return null;
  }

  if (slug.length === 0) {
    if (data?.showForAllUsers) {
      return <HeroBanner {...data} />;
    }
    return <HeroBanner {...bannerData} />;
  }

  return null;
};

export default HeroBannerTastic;
